export type HeyGenAvatarConfig = {
	apiBaseUrl: string;
	apiKey: string;
	avatarId: string;
	voiceId: string;
	knowledgeId: string;
	language: string;
};

export const HEYGEN_AVATAR_CONFIG: HeyGenAvatarConfig = {
	apiBaseUrl:
		process.env.EXPO_PUBLIC_HEYGEN_API_URL || "https://api.heygen.com",
	apiKey:
		process.env.EXPO_PUBLIC_HEYGEN_API_KEY ||
		process.env.EXPO_PUBLIC_LIVEAVATAR_API_KEY ||
		"",
	avatarId:
		process.env.EXPO_PUBLIC_HEYGEN_AVATAR_ID ||
		process.env.EXPO_PUBLIC_LIVEAVATAR_AVATAR_ID ||
		"",
	voiceId:
		process.env.EXPO_PUBLIC_HEYGEN_VOICE_ID ||
		process.env.EXPO_PUBLIC_LIVEAVATAR_VOICE_ID ||
		"",
	knowledgeId:
		process.env.EXPO_PUBLIC_HEYGEN_KNOWLEDGE_ID ||
		process.env.EXPO_PUBLIC_LIVEAVATAR_CONTEXT_ID ||
		"",
	language: process.env.EXPO_PUBLIC_HEYGEN_LANGUAGE || "en",
};

export const hasHeyGenAvatarConfig = () =>
	Boolean(HEYGEN_AVATAR_CONFIG.apiKey && HEYGEN_AVATAR_CONFIG.avatarId);
